import React from "react";
import TMSIframe from "../iframe-component/TMSIframe";

const RKI = () => {
  return <TMSIframe path="/RKI" />;
};

export default React.memo(RKI);
